import { render, staticRenderFns } from "./UploadCommentView.vue?vue&type=template&id=2005234c&"
import script from "./UploadCommentView.vue?vue&type=script&lang=js&"
export * from "./UploadCommentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports